/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pricing.discounts.sidebar.controllers', [
  'ui.router',
  'acme.common.service.api',
  'acme.common.service.helpers'
])

.controller('PricingDiscountsSidebarController', ['$scope', '$state', 'HelpersService', 'ApiService', function($scope, $state, HelpersService, ApiService) {

    $scope.pricingDiscountsSidebar = {

      title: 'Manage your pricing from here',
      model: [],

      search: {},

      selectedDiscountCodeId: false,

      init: function() {
        $scope.$on('PricingDiscountsController::discountCodesUpdate', this.onDiscountCodesUpdate);
      },

      selectDiscountCode: function(id) {
        console.log('PricingDiscountsSidebarController::selectDiscountCodes');
        this.selectedDiscountCodeId = id;
        $scope.$emit('PricingDiscountsSidebarController::selectList', { id: id });
      },

      isSelected: function(id) {
        return (id === this.selectedDiscountCodeId);
      },

      sortByName: function(list) {
        list.sort(function(a, b) {
          var r = 0;

          if (a.name.toLowerCase() < b.name.toLowerCase()) {
            r = -1;
          }else if (a.name.toLowerCase() > b.name.toLowerCase()) {
            r = 1;
          }
          return r;
        });

        return list;
      },

      sortByDate: function() {},

      onDiscountCodesUpdate: function(e, data) {
        var self = $scope.pricingDiscountsSidebar;
        console.log('PricingDiscountsSidebarController::onDiscountCodesUpdate', data);
        self.model = self.sortByName(data.model);
        if (data.selectedDiscountCodeId) {
          self.selectedDiscountCodeId = data.selectedDiscountCodeId;
        }else if (self.model instanceof Array && self.model.length > 0) {
          self.selectedDiscountCodeId = self.model[0].id;
        }

        if (self.selectedDiscountCodeId !== false) {
          self.selectDiscountCode(self.selectedDiscountCodeId);
        }
      }

    };

    $scope.pricingDiscountsSidebar.init();

}]);